// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adCBb5ZbPaAfu03hz__1{flex-direction:column;margin-top:-4px;padding:0 11px;display:flex}.adCBb5ZbPaAfu03hz__1.D1Yvu3nHrCIXWB2iOY_k{padding:12px}.MiSsEn4SrgEd99GgHdko{padding:0 12px 24px 11px}.iYo5yU9OeYEpVWKizYrF .MiSsEn4SrgEd99GgHdko{padding-top:18px}.MiSsEn4SrgEd99GgHdko>div{padding:0}.MiSsEn4SrgEd99GgHdko>div>div{padding-bottom:5px}._iJVuEzEaAxzFagzEX10{margin-top:13px;padding:0 8px;display:flex}._iJVuEzEaAxzFagzEX10 button{z-index:var(--zIndex-BASE_1);position:relative}.iIwP9KmBKrUedVKbfuAU{flex-direction:column;gap:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `adCBb5ZbPaAfu03hz__1`,
	"fullView": `D1Yvu3nHrCIXWB2iOY_k`,
	"messageField": `MiSsEn4SrgEd99GgHdko`,
	"open": `iYo5yU9OeYEpVWKizYrF`,
	"showMore": `_iJVuEzEaAxzFagzEX10`,
	"notes": `iIwP9KmBKrUedVKbfuAU`
};
export default ___CSS_LOADER_EXPORT___;
